/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRadioSet = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M5 16a3 3 0 1 1-.001 6.001A3 3 0 0 1 5 16zm0 2a1 1 0 1 0 .001 2.001A1 1 0 0 0 5 18zm17 0v2H10v-2zM5 9a3 3 0 1 1-.001 6.001A3 3 0 0 1 5 9zm0 2a1 1 0 1 0 .001 2.001A1 1 0 0 0 5 11zm17 0v2H10v-2zM5 2c1.654 0 3 1.346 3 3S6.654 8 5 8 2 6.654 2 5s1.346-3 3-3zm17 2v2H10V4z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgRadioSet as RadioSet };
